import React, { useState, useEffect } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from "reactstrap";

import ImageGallery from "../../gallery/index";

const ProductImage = ({
    visible,
    toggle,
    images,
    propertyId,
    onDone
}) => {

    const [imageLinks, setImageLinks] = useState([]);
    const [galleryVisible, setGalleryVisible] = useState(false);

    useEffect(() => {
        if (images) {
            setImageLinks(images);
        }
    }, [images]);

    const toggleGallery = () => {
        setGalleryVisible(!galleryVisible);
    };

    const selectedImage = (image) => {

        if (!imageLinks.includes(image.src)) {
            setImageLinks(prev => [...prev, image.src]);
        }

        setGalleryVisible(false);
    };

    const removeImage = (index) => {
        const updated = [...imageLinks];
        updated.splice(index, 1);
        setImageLinks(updated);
    };

    const handleDone = () => {
        onDone(imageLinks);
        toggle();
    };

    return (
        <>
            <Modal isOpen={visible} toggle={toggle} size="lg">

                <ModalHeader toggle={toggle}>
                    Additional Images
                </ModalHeader>

                <ModalBody>

                    {/* Selected Images */}
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {imageLinks.map((img, index) => (
                            <div key={index} style={{ position: "relative", margin: 10 }}>

                                <img
                                    src={img}
                                    alt="product"
                                    style={{
                                        width: 120,
                                        height: 120,
                                        objectFit: "cover",
                                        borderRadius: 6
                                    }}
                                />

                                <span
                                    onClick={() => removeImage(index)}
                                    style={{
                                        position: "absolute",
                                        top: -5,
                                        right: -5,
                                        cursor: "pointer",
                                        color: "red",
                                        fontWeight: "bold"
                                    }}
                                >
                                    ✕
                                </span>

                            </div>
                        ))}
                    </div>

                    <Button
                        color="secondary"
                        className="mt-2"
                        onClick={toggleGallery}
                    >
                        Browse Gallery
                    </Button>

                </ModalBody>

                <ModalFooter>

                    <Button color="primary" onClick={handleDone}>
                        Done
                    </Button>

                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>

                </ModalFooter>

            </Modal>

            {/* Gallery Modal */}

            <Modal
                isOpen={galleryVisible}
                toggle={toggleGallery}
                style={{ maxWidth: "1000px" }}
            >
                <ModalHeader toggle={toggleGallery}>
                    Select Image
                </ModalHeader>

                <ModalBody>

                    <ImageGallery
                        propertyId={propertyId}
                        selectedImage={selectedImage}
                        togglegallery={toggleGallery}
                        hideUserUploads={false}
                        searchText=""
                    />

                </ModalBody>

            </Modal>
        </>
    );
};

export default ProductImage;